import { Injectable } from '@angular/core';
import { Api } from '../contracts/classes/api.class';
import { firstValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ImageService extends Api {

  /**
   * @deprecated
   * @description Usado en Pipe
   * todo: reemplazar implementación por rutas directas a las imgs
   * @param url 
   * @returns 
   */
  get(url: string) {
    return this.http.get(url, { responseType: 'blob' }).toPromise();
  }

  getUrl(url: string): Promise<any> {
    return this.http.get<any>(url).toPromise();
  }

  avatar(path: string): string {
    return `${this.source}/picture/users/${path}`;
  }
}
